import * as React from 'react';
import * as styles from './index.css';
// tslint:disable-next-line: match-default-export-name
import cx from 'classnames';

export type TIconType = 'video' | 'layout' | 'photo' | 'floor-plan' | 'cian-layout';

const title: { [index: string]: string } = {
  layout: 'Планировка',
  'cian-layout': 'Планировка от Циан',
  photo: 'фото',
  video: 'Видео',
  'floor-plan': 'На интерактивном плане',
};

export interface IControlsProps {
  type: TIconType;
  id: number;
  elementsCount: number;
  onButtonClick(id: number): void;
}

export class MenuButton extends React.Component<IControlsProps, {}> {
  public render() {
    return (
      <div
        className={cx(styles['menu_button'], { [styles['menu_button--floor-plan']]: this.props.type === 'floor-plan' })}
        onClick={() => {
          this.props.onButtonClick(this.props.id);
        }}
      >
        <div className={styles[`icon-${this.props.type}`]} />
        <div className={styles['title']}>{getTitle(this.props.type, this.props.elementsCount)}</div>
      </div>
    );
  }
}

export function getTitle(type: TIconType, count: number) {
  return type === 'photo' ? `${count} ${title[type]}` : title[type];
}
